<template>
  <div
    class="flex flex-col items-center p-8 text-center bg-white rounded-3xl border border-gray-200 transition-shadow hover:shadow-xl"
  >
    <div
      class="flex justify-center items-center mb-6 w-16 h-16 text-white rounded-full bg-brand-red"
    >
      <component :is="icon"></component>
    </div>
    <h3 class="mb-3 text-2xl font-bold">{{ title }}</h3>
    <p class="flex-grow mb-6 text-brand-gray">{{ description }}</p>
    <a
      href="#"
      :class="[
        'font-semibold flex items-center gap-2',
        isPrimary ? 'text-brand-red' : 'text-brand-red',
      ]"
    >
      {{ linkText }} <ArrowRightIcon />
    </a>
  </div>
</template>

<script>
import { ArrowRightIcon } from "./icons/";
import { ChatIcon, ProductIcon, ServiceIcon } from "./icons/";

export default {
  name: "SupportCard",
  components: {
    ArrowRightIcon,
    ChatIcon,
    ProductIcon,
    ServiceIcon,
  },
  props: {
    icon: String,
    title: String,
    description: String,
    linkText: String,
    isPrimary: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
